<template>
    <div class="bg-gradient-loch row">
        <div class="home my-4 px-4 container">
            <div class="row mb-4">
                <div class="col-12">
                    <div class="card shadow mx-auto mt-4 max-width-4 bg-light px-lg-5 px-md-0 px-lg-5">
                        <div class="card-body px-lg-5 text-left">
                            <h2 class="mb-4 mt-3 text-center">Activating your account</h2>
                            <div v-if="isLoading">
                                <loading isLoading></loading>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {
    mapActions,
    mapState,
} from 'vuex'

const whitelabel = require('../../../../whitelabel.config')[process.env.VUE_APP_BRAND]

export default {
    name: 'Home',
    components: {
    },
    data() {
        return {
            name: whitelabel.brand,
            code: '',
        }
    },
    methods: {
        ...mapActions([
            'activateUser',
        ]),
        ...mapState([
            'isLoading',
        ]),
        activate() {
            this.activateUser({
                params: {
                    code: this.$route.query.code,
                },
            })
            this.$router.push({ name: 'Login' })
        },
    },
    mounted() {
        this.activate()
    },
}
</script>
